var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInformativeEmptyStateFind(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h32v32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 20.1778c.7926 0 1.4611-.2722 2.0055-.8167.5445-.5444.8167-1.2129.8167-2.0055s-.2722-1.4611-.8167-2.0056c-.5444-.5444-1.2129-.8166-2.0055-.8166s-1.4612.2722-2.0056.8166c-.5445.5445-.8167 1.213-.8167 2.0056 0 .7926.2722 1.4611.8167 2.0055.5444.5445 1.213.8167 2.0056.8167Zm8.1778 6.9334-5.4556-5.4556c-.4222.2592-.8537.4481-1.2945.5666-.4407.1186-.9166.1778-1.4277.1778-1.4074 0-2.6-.4889-3.5778-1.4666-.9778-.9778-1.4667-2.1704-1.4667-3.5778s.4889-2.6 1.4667-3.5778c.9778-.9778 2.1704-1.4666 3.5778-1.4666s2.5999.4888 3.5777 1.4666c.9778.9778 1.4667 2.1704 1.4667 3.5778 0 .5111-.0704.9963-.2111 1.4555-.1408.4593-.3482.8704-.6222 1.2334l4.2333 4.2333V11.3889l-5.5778-6.5H7.5562v22.2223h16.6223ZM7.5562 29.3334c-.6 0-1.1204-.2204-1.5611-.6611-.4407-.4408-.6611-.9611-.6611-1.5611V4.8889c0-.6.2204-1.1204.661-1.5611.4408-.4407.9612-.6611 1.5612-.6611h11.2556c.33 0 .6417.068.9351.204.2934.136.5409.331.7426.5849l5.6334 6.5667c.1778.2.3129.4227.4055.6683a2.15 2.15 0 0 1 .1389.765v15.6556c0 .6-.2203 1.1203-.6611 1.5611-.4407.4407-.9611.6611-1.5611.6611H7.5561Z",
    fill: "#8999B1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformativeEmptyStateFind);
export default __webpack_public_path__ + "static/media/informative-empty-state-find.6b9c3cf6ce7998411b92deaf5de5fe25.svg";
export { ForwardRef as ReactComponent };